const Divider = () => {
  return (
    <>
      <div className='divider'></div>
    </>
  );
};
export default Divider;
